import { TRANSACTION_STATE } from '@wellbeingxltd/fe-lib/constants'
import { ACTIONS } from 'actions/transactions'

export const initialState = {
    database: [],
    appState: {
        next: {},
        transactionCancel: TRANSACTION_STATE.NONE,
        transactionState: TRANSACTION_STATE.NONE,
        transactionCounter: 0,
        transaction: {},
        transactionsLoaded: false,
        transactionsLoading: false,
        transactionError: null,
        transactionHelp: {
            answers: {
                msg: '',
                reason: '',
                what: '',
                whatKey: '',
            },
            error: '',
            loading: false,
            transaction: {},
        },
        transactionsCountedByAutomationType: null,
        selectedAutomationType: 'All',
    },
    card: null,
    payment: null,
    nextAction: false,
    loadingPostTransaction: false,
}

const transactionsReducer = (state = initialState, action) => {
    const { appState, database } = state
    let newAppState = { ...appState }
    let newDatabase = [...database]

    switch (action.type) {
        case ACTIONS.GET_TRANSACTIONS.START:
            return {
                ...state,
                appState: {
                    ...appState,
                    transactionsLoading: true,
                },
            }

        case ACTIONS.GET_TRANSACTIONS.SUCCESS:
            const automationTypes = action.data.map(transaction => transaction.automationType).filter(item => typeof item === 'string') || []

            const transactionsCountedByAutomationType = automationTypes.reduce(
                (acc, curr) => {
                    acc[curr] = (acc[curr] || 0) + 1
                    return acc
                },
                { All: automationTypes.length }
            )

            return {
                ...state,
                appState: {
                    ...appState,
                    transactionsLoaded: true,
                    transactionsLoading: false,
                    transactionCounter: action.data.length,
                    transactionsCountedByAutomationType,
                },
                database: [...action.data.sort((b, a) => new Date(a.date) - new Date(b.date))],
            }

        case ACTIONS.GET_TRANSACTIONS.FAILURE:
            return {
                ...state,
                appState: {
                    ...appState,
                    transactionsLoaded: false,
                    transactionsLoading: false,
                },
            }

        case ACTIONS.POST_TRANSACTION.START:
            appState.transactionState = TRANSACTION_STATE.FETCHING
            return {
                ...state,
                appState,
                loadingPostTransaction: true,
            }
        case ACTIONS.POST_TRANSACTION.SUCCESS:
            return {
                ...state,
                appState: {
                    ...state.appState,
                    transactionState: TRANSACTION_STATE.SUCCESS,
                    transactionError: null,
                },
                payment: action.data?.payment || null,
                nextAction: action.data?.nextAction || false,
                loadingPostTransaction: false,
                database: [...(action.data?.transactions || [])],
            }

        case ACTIONS.POST_TRANSACTION.FAILURE:
            return {
                ...state,
                appState: {
                    ...state.appState,
                    transactionState: TRANSACTION_STATE.ERROR,
                    transactionError: action.error,
                },
                payment: null,
                nextAction: false,
                loadingPostTransaction: false,
            }

        case ACTIONS.CLEAN_TRANSACTION:
            return {
                ...state,
                appState: {
                    ...appState,
                    transactionState: TRANSACTION_STATE.NONE,
                    transaction: {},
                    transactionError: null,
                },
            }

        case ACTIONS.STORE_TRANSACTION_TO_REDUX:
            return {
                ...state,
                appState: {
                    ...newAppState,
                    transaction: { ...action.transaction },
                },
            }

        case ACTIONS.TRANSACTION_UPDATE:
            newDatabase[newDatabase.findIndex(el => el.transactionId === action.data.transactionId)] = { ...action.data }

            return {
                ...state,
                database: [...newDatabase],
            }

        case ACTIONS.TRANSACTION_UPDATE_PAYMENTMETHODID:
            appState.transaction.paymentMethodId = action.paymentMethodId
            return {
                ...state,
                appState,
            }
        case ACTIONS.CANCEL_TRANSACTION.START:
            newAppState.transactionCancel = TRANSACTION_STATE.START
            return {
                ...state,
                appState: newAppState,
            }
        case ACTIONS.CANCEL_TRANSACTION.SUCCESS:
            newAppState.transactionCancel = action.data
            return {
                ...state,
                appState: newAppState,
            }
        case ACTIONS.CANCEL_TRANSACTION.FAILURE:
            newAppState.transactionCancel = TRANSACTION_STATE.ERROR
            return {
                ...state,
                appState: newAppState,
            }
        case ACTIONS.CANCEL_TRANSACTION_STOP:
            newAppState.transactionCancel = TRANSACTION_STATE.NONE
            return {
                ...state,
                appState: newAppState,
            }

        case ACTIONS.STORE_HELP_TRANSACTION:
            newAppState.transactionHelp.transaction = action.data

            return {
                ...state,
                appState: newAppState,
            }

        case ACTIONS.UPDATE_HELP_ANSWER:
            // Take the key-value and override the key-value of the reducer
            newAppState.transactionHelp.answers = {
                ...newAppState.transactionHelp.answers,
                ...action.data,
            }

            return {
                ...state,
                appState: newAppState,
            }

        case ACTIONS.UPDATE_HELP_ERROR:
            newAppState.transactionHelp.error = action.data

            return {
                ...state,
                appState: newAppState,
            }

        case ACTIONS.CLEAN_TRANSACTION_HELP:
            newAppState.transactionHelp = {
                answers: {
                    msg: '',
                    reason: '',
                    what: '',
                    whatKey: '',
                },
                error: '',
                transaction: {},
            }

            return {
                ...state,
                appState: newAppState,
            }

        case ACTIONS.POST_TRANSACTION_HELP.START:
            newAppState.transactionHelp = {
                ...newAppState.transactionHelp,
                loading: true,
            }
            return {
                ...state,
                appState: newAppState,
            }
        case ACTIONS.POST_TRANSACTION_HELP.SUCCESS:
            newAppState.transactionHelp = {
                ...newAppState.transactionHelp,
                loading: false,
            }
            return {
                ...state,
                appState: newAppState,
            }
        case ACTIONS.POST_TRANSACTION_HELP.FAILURE:
            newAppState.transactionHelp = {
                ...newAppState.transactionHelp,
                loading: false,
            }
            return {
                ...state,
                appState: newAppState,
            }

        case ACTIONS.STORE_CARD_ELEMENT_TO_REDUX:
            return {
                ...state,
                card: action.card,
            }

        case ACTIONS.REMOVE_CARD_ELEMENT_FROM_REDUX: {
            return {
                ...state,
                card: null,
                payment: null,
            }
        }

        case ACTIONS.SET_SELECTED_AUTOMATION_TYPE: {
            return { ...state, appState: { ...state.appState, selectedAutomationType: action.automationType } }
        }

        case ACTIONS.STORE_CARD_ELEMENT_TO_REDUX:
            return {
                ...state,
                card: action.card,
            }

        case ACTIONS.REMOVE_CARD_ELEMENT_FROM_REDUX: {
            return {
                ...state,
                card: null,
                payment: null,
            }
        }

        case ACTIONS.SET_SELECTED_AUTOMATION_TYPE: {
            return { ...state, appState: { ...state.appState, selectedAutomationType: action.automationType } }
        }

        default:
            return state
    }
}

export default transactionsReducer
